import { Box } from '@mui/material'
import { useRightPanel } from './RightPanelContext'
import { useResizeDrag } from '@/common/hooks/useResizeDrag'

export function RightPanelSlot() {
  const { content, panelWidth, setPanelWidth } = useRightPanel()

  const startResize = useResizeDrag({
    cssVar: '--right-panel-width',
    direction: 'left',
    minWidth: 200,
    maxWidth: 900,
    onResizeEnd: setPanelWidth,
  })

  if (!content) return null

  return (
    <Box
      sx={{
        gridColumn: 3,
        gridRow: 2,
        zIndex: 100,
        height: '100%',
        overflow: 'hidden auto',
        boxShadow: '-4px 0 20px rgba(0,0,0,0.22)',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '4px',
          height: '100%',
          cursor: 'col-resize',
          zIndex: 10,
          '&:hover': { bgcolor: 'primary.main', opacity: 0.4 },
        }}
        onMouseDown={(e) => startResize(e, panelWidth)}
      />
      {content}
    </Box>
  )
}
